import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "messaging/form-templates/:templateId",
  exact: true,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import("./components"),
      import("MessagingV2/modules/MessagingModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const module = importedModule1;
      injectReducer(store, {
        key: module.NAME,
        reducer: module.default,
      });
      return component;
    })
  ),
});
